import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteConfig';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="text-lg font-heading font-semibold text-background-50 mb-4">
              {siteConfig.name}
            </h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteConfig.tagline}
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href={siteConfig.social.weibo}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800/50 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800/50 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                aria-label="微信"
              >
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a
                href={`mailto:${siteConfig.contact.email}`}
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800/50 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                aria-label="邮箱"
              >
                <i className="ri-mail-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              开运分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  隐私政策
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  使用条款
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="flex flex-col gap-2">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line text-sm"></i>
                <span>{siteConfig.contact.phone}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-sm"></i>
                <span>{siteConfig.contact.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line text-sm"></i>
                <span>{siteConfig.address.full}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteConfig.name} 版权所有
          </p>
          <p className="text-xs text-foreground-600">
            本站内容仅供参考，不构成专业建议
          </p>
        </div>
      </div>
    </footer>
  );
}